import axios from "axios";

export async function getAllCoins(currency) {
    try {
        const responce = await axios.get(`https://api.coingecko.com/api/v3/coins/markets?vs_currency=${currency}&order=market_cap_desc&per_page=100&page=1&sparkline=false&locale=en`);
        // console.log(responce);
        return responce.data;
      }
      catch (error) {
        console.log(new Error(error));
        return Promise.reject(error);
      }
}